import shopcarBreadCrumb from "./shopcarBreadCrumb";
import TopBar from "./TopBar";
import Header from "./Header";
import PageFenye from "./PageFenye";
import PickerRiQi from "./PickerRiQi";
import Footer from "./Footer";
import Lang from "./Lang";
import LoginDialog from "./LoginDialog";

export default {
	install(Vue) {
		Vue.component("shopcarBreadCrumb", shopcarBreadCrumb);
		Vue.component("TopBar", TopBar);
		Vue.component("Header", Header);
		Vue.component("PageFenye", PageFenye);
		Vue.component("PickerRiQi", PickerRiQi);
		Vue.component("Footer", Footer);
		Vue.component("Lang", Lang);
		Vue.component("LoginDialog", LoginDialog);
	},
};
